var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ pageTitle: !_vm.$isWeb, 'h5-pageTitle': _vm.$isWeb }},[_vm._v(" "+_vm._s(this.title)),_c('span',{staticClass:"icon"})])}
var staticRenderFns = []

export { render, staticRenderFns }